<script>
export default {
  name: "customizeReporting",
  data() {
    return {
      customOptions: {

        // 请求的列表url
        url: "/api/v1/manage/line/driver/register",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          ...this.$route.query,
          schedulingTime: ''
        },
      },
      columns: [
        {prop: "driverName", label: "司机姓名"},
        {prop: "driverPhone", label: "手机号码"},
        {prop: "licenseNo", label: "车辆号牌"},
        {prop: "startServiceTime", label: "服务时段"},
        {prop: "created", label: "报班时间"},
      ],
      timeList: [],
      driverRegister: String(this.$route.query.driverRegister),
      dateActiveIndex: 0,
    }
  },
  created() {
    this.timeList = [
      this.getFutureWeekZeroHours(0),
      this.getFutureWeekZeroHours(1),
      this.getFutureWeekZeroHours(2),
      this.getFutureWeekZeroHours(3),
      this.getFutureWeekZeroHours(4),
      this.getFutureWeekZeroHours(5),
      this.getFutureWeekZeroHours(6),
    ]
    this.customOptions.params.schedulingTime = this.timeList[this.dateActiveIndex]

  },
  methods: {
    getFutureWeekZeroHours(index) {
      const now = new Date();
      const futureWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() + index);
      return Math.floor(futureWeek.getTime() / 1000);
    },
    async getRegisterFn() {
      const url = '/api/v1/manage/line/driver/register'
      const {code} = await this.$axios.post(url, {
        lineId: this.$route.query.lineId,
        driverRegister: this.driverRegister == 1 ? 2 : 1
      })
      if (code == 1) {
        this.$message.success('操作成功')
        this.driverRegister = this.driverRegister == 1 ? '2' : '1'
      }

    },
    dateClick(row, index) {
      this.dateActiveIndex = index
      this.customOptions.params.schedulingTime = row
      this.$refs.customTable.listFn()
    }

  }
}
</script>

<template>
  <div class="customizeReporting">
    <div class="blueInfo">
      <p>* 开放线路报班后，司机可在司机端APP上报该线路的可服务时段，平台可根据司机报班情况动态调整线路班次</p>
      <p>* 司机仅可报班机构名称的线路</p>
    </div>

    <div style="height: calc(100% - 60px)">
      <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :has-organization="true">

        <template slot="search-top-left" >
            <div >
              <customTabTime :showArrow="false" @dateClick="dateClick" :dateActiveIndex="dateActiveIndex" :prohibitDelete="true"
                             :time-list="timeList"></customTabTime>
            </div>
        </template>
        <template slot="search-top-right">
          <span>开放线路报班</span>
          <el-switch
              :value="driverRegister"
              @click.native="getRegisterFn"
              active-value="1"
              style="margin-right: 10px"
              inactive-value="2">
          </el-switch>

        </template>
        <template slot-scope="{ item, row }">
          <template v-if="item.prop === 'created'">{{
              row.created | filterTime
            }}
          </template>
          <template v-else-if="item.prop === 'startServiceTime'">
            <span>{{
                row.startServiceTime
              }} ~ {{
                row.endServiceTime
              }}</span>
          </template>
          <template v-else-if="item.prop === 'licenseNo'">
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-else>-</span>
            <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
          </template>

          <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
        </template>

      </custom-table>

    </div>
  </div>
</template>

<style scoped lang="less">

</style>